import { render, staticRenderFns } from "./SliderHeros.vue?vue&type=template&id=580c4d1a&"
import script from "./SliderHeros.vue?vue&type=script&lang=js&"
export * from "./SliderHeros.vue?vue&type=script&lang=js&"
import style0 from "./SliderHeros.vue?vue&type=style&index=0&id=580c4d1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoSliderHero: require('/vercel/path0/components/heros/NoSliderHero.vue').default})
